module.exports = __webpack_public_path__ + "img/mass-production-2.c0e4fe39.png";